import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PageContainer from 'common/components/pageContainer/PageContainer';
import PageHeader from 'common/components/pageHeader/PageHeader';
import FamiliesService from 'api/families/FamiliesService';
import Toast from 'common/services/Toast';
import Loading from 'common/services/Loading';

function GodModeScreen (): JSX.Element {
    const { t } = useTranslation();
    const [recalculateResult, setRecalculateResult] = useState<string | null>(null);

    const handleRecalculateAverages = async () => {
        try {
            Loading.show();
            const result = await FamiliesService.recalculateAllAverages();
            setRecalculateResult(`${result.count} famílias enviadas para recálculo.`);
            Toast.success(`${result.count} famílias enviadas para recálculo.`);
        } catch (error) {
            Toast.error(t('common.messages.unexpected_error'));
        } finally {
            Loading.hide();
        }
    };

    return (
        <PageContainer>
            <PageHeader title="God Mode" informationText="Ferramentas de administração" />
            <div style={{ padding: '1rem' }}>
                <h5>Recálculo de médias de famílias</h5>
                <p>Envia um job para recalcular a média de todas as famílias que tenham expressão de média definida.</p>
                <Button variant="warning" onClick={handleRecalculateAverages}>
                    Recalcular médias de todas as famílias
                </Button>
                {recalculateResult && (
                    <div style={{ marginTop: '1rem' }}>
                        <strong>{recalculateResult}</strong>
                    </div>
                )}
            </div>
        </PageContainer>
    );
}

export default GodModeScreen;
